export enum EReceiveStatus {
  NEW = "N",
  IN_PROGRESS = "P",
  COMPLETE = "C",
}
